module.exports = __webpack_public_path__ + "static/media/logo4.40b8632c.svg";